export enum SecretKeyTypeEnum {
  USER_TOKEN = 'userTokenKey',
  ADMIN_TOKEN = 'adminTokenKey',
  API_TOKEN = 'apiTokenKey',
  STORAGE_TOKEN = 'storageTokenKey',
}
